import { SafeUrl } from '@angular/platform-browser';
import { WorkflowItem } from './workflow-item.model';
import { getFileNameFromPath } from 'app/_utils/file-path.utils';
import DateTimeUtils from 'app/_utils/datetime.utils';

export class ContractorCompetencyWorkflowItem extends WorkflowItem {
  maintenanceSiteOwnerCompetencyTypeId: number;
  certificateStatus: string;
  competencyTypeId: string;
  competencyType: string;
  comments: string;
  expiryDate: Date;
  files: { fileName: string, safeUrl?: SafeUrl }[];
  maintenanceId: number;
  maintenanceName: string;

  public deserialize(input: any): this {
    super.deserialize(input);

    this.maintenanceSiteOwnerCompetencyTypeId = input.maintenanceSiteOwnerCompetencyType.id;
    this.certificateStatus = input.maintenanceSiteOwnerCompetencyType.status;
    this.competencyTypeId = input.maintenanceSiteOwnerCompetencyType.competencyType.id;
    this.competencyType = input.maintenanceSiteOwnerCompetencyType.competencyType.value;
    this.comments = input.comments;
    this.expiryDate = this.parseExpiryDate(input.maintenanceSiteOwnerCompetencyType.expiryDate);
    this.files = input.maintenanceSiteOwnerCompetencyType.files.map(f => ({ fileName: getFileNameFromPath(f.fileName) }));
    this.maintenanceId = input.maintenanceSiteOwnerCompetencyType.maintenanceId;
    this.maintenanceName = input.maintenanceSiteOwnerCompetencyType.maintenanceName;

    this.details = this.competencyType;
    return this;
  }

  public getTaskDetails(): string {
    return `Contractor ${this.maintenanceName} - certificate needs approval`;
  }

  private parseExpiryDate(value: any): Date {
    if (!value) {
      return null;
    }

    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return DateTimeUtils.timelessDateStrAsUTCDate(value);
    }

    return this.parseDate(value);
  }
};
